export function sanitizePdfFilenameBase(name) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Document';
  var cleaned = String(name || '').replace(/[<>:"/\\|?*\x00-\x1F]+/g, '-').replace(/\s+/g, ' ').trim().replace(/[^\w\s.\-()]+/g, '').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '').slice(0, 120);
  return cleaned || fallback;
}
export function buildPdfFilename(baseName) {
  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'single';
  var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Document';
  var base = sanitizePdfFilenameBase(baseName, fallback);
  return mode === 'paged' ? "".concat(base, "-page-wise.pdf") : "".concat(base, "-single-page.pdf");
}
export function filenameFromContentDisposition(disposition) {
  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'single';
  var fallbackBase = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'Document';
  var header = disposition || '';
  var utf8Match = /filename\*=(?:UTF-8''|utf-8'')([^;]+)/i.exec(header);
  if (utf8Match !== null && utf8Match !== void 0 && utf8Match[1]) {
    try {
      return decodeURIComponent(utf8Match[1].trim().replace(/^"+|"+$/g, ''));
    } catch (error) {
      // fall through
    }
  }
  var plainMatch = /filename="?([^";]+)"?/i.exec(header);
  if (plainMatch !== null && plainMatch !== void 0 && plainMatch[1]) {
    return plainMatch[1].trim();
  }
  return buildPdfFilename(fallbackBase, mode, fallbackBase);
}